import { Data } from '@angular/router';
import { Injector, Type } from '@angular/core';

export class PortalInjector implements Injector {
    constructor(
        private readonly parentInjector: Injector,
        private readonly customTokens: WeakMap<Data, Data>,
    ) {}

    public get(token: Type<Data>, notFoundValue?: Data): Data {
        const value = this.customTokens.get(token);

        if (typeof value !== 'undefined') {
            return value;
        }

        return this.parentInjector.get<Data>(token, notFoundValue);
    }
}
